import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import NoData from '../../components/NoData/NoData';

const categories = [
  'Mar 01', 'Mar 02', 'Mar 03', 'Mar 04', 'Mar 05', 'Mar 06', 'Mar 07',
  'Mar 08', 'Mar 09', 'Mar 10', 'Mar 11', 'Mar 12', 'Mar 13', 'Mar 14',
  'Mar 15', 'Mar 16', 'Mar 17', 'Mar 18', 'Mar 19', 'Mar 20', 'Mar 21',
  'Mar 22', 'Mar 23', 'Mar 24', 'Mar 25', 'Mar 26', 'Mar 27', 'Mar 28',
  'Mar 29', 'Mar 30', 'Mar 31'
];

const columnData = [
  null, 3, 8, 3, 1, 12, 10, null, null, 8,
  5, 6, 7, 2, null, null, 3, 8, 7, 5,
  9, null, null, 10, 8, 7, 6, 3, null, null, 5
];

// Replace null with 0 for chart data
const data = columnData.map(val => val === null ? 0 : val);

// Check if data is empty or all zero
const isEmpty = !data.length || data.every(value => value === 0);

const MonthlyBarChart = () => {
  const options = {
    chart: {
      type: 'column',
      height: 400,
      backgroundColor: 'transparent',
    },
    title: {
      text: 'Total hours worked per day',
      align: 'left',
      x: 0,
      style: {
        fontWeight: '500',
        fontSize: '17px',
        color: '#1A1F36',
      },
    },
    xAxis: {
      categories: categories,
      title: { text: 'Date' },
      labels: { rotation: -45 },
      gridLineWidth: 0,
      lineColor: '#ccc',
      tickColor: '#ccc',
    },
    yAxis: {
      min: 0,
      title: { text: 'Hours Worked' },
      gridLineWidth: 0,
      lineColor: '#ccc',
      tickColor: '#ccc',
    },
    tooltip: { valueSuffix: ' hrs' },
    legend: { enabled: false },
    series: [{
      name: 'Worked Hours',
      data: data,
      color: '#FF8328',
    }],
    credits: { enabled: false },
  };

  return isEmpty ? <NoData /> : <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default MonthlyBarChart;
